'use strict';

angular.module('ListAccessRequestControllers')

.controller('LookupEmployeeController', ['$scope', '$state', '$stateParams', 'searchService', function ($scope, $state, $stateParams, searchService) {

    // Search
    $scope.employees = null;
    $scope.ctxLookup = {};
    $scope.ctxLookup.searchTerm = null;

    $scope.searchEmployees = function () {
        if (_.isEmpty($scope.ctxLookup.searchTerm) || $scope.ctxLookup.searchTerm.length < 2) {
            $scope.employees = null;
            return;
        }

        searchService.searchEmployees($scope.ctxLookup.searchTerm)
        .then(function (employees) {
            $scope.employees = employees;
        });
    }

    // When enter, go to page with first employee
    $scope.goToFirstEmployee = function () {
        if (!($scope.employees.length > 0)) { return; }

        var employee = $scope.employees[0];
        $state.go('userAccessRequest.request.byEmployeeId', { employeeId: employee.EmployeeID });
    }
}]);